import eventBus from '@tools/event-bus';

export default function (selector, redirectUrl) {
  document
    .querySelectorAll(selector)
    .forEach((element) => {
      element.addEventListener('click', () => {
        eventBus.dispatchEvent(new CustomEvent('show-login-modal', {
          detail: {
            email: null,
            redirectUrl,
          },
        }));
      });
    });
}
